import MozartApi from './MozartApi';
import Config from '../../config'

export default class ApiConfig {
    constructor(keycloak) {
        this.coreurl = Config.coreurl
        this.aiapiurl = Config.aiapiurl
        this.alertapiurl = Config.alertapiurl
        this.payloadapiurl = Config.payloadapiurl
        // this.coreurl = "https://robot.spartan-360.com"
        this.mozartApi = new MozartApi(keycloak)
    }
    api = function() {
        return {
          // Robot Payload API
            fetchAllPayloads :  async (page, pageSize, searchText="") =>{
              try {
                console.log("Fetching all Payloads")
                const params = new URLSearchParams();
                if (page !== undefined && page !== null) params.set('page', page);
                if (pageSize !== undefined && pageSize !== null) params.set('page_size', pageSize);
                if (searchText) params.set('search', searchText);
                const query = params.toString();
                return this.mozartApi.get(`${this.payloadapiurl}/payload/${query ? `?${query}` : ''}`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayload: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createPayload: async (payload) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/payload/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            updatePayload: async (id, payload) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/payload/${id}/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            deletePayload: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/payload/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Payload authentication API
            fetchAllPayloadAuthentications :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/authentication/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadAuthentication: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/authentication/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadAuthenticationByPayloadId: async (payloadId) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/authentication/api/get_authentication_by_payload/${payloadId}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createPayloadAuthentication: async (payload) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/payload/authentication/api/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            updatePayloadAuthentication: async (id, payload) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/payload/authentication/api/${id}/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            deletePayloadAuthentication: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/payload/authentication/api/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Payload workflow API
            fetchAllPayloadWorkflows :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflow: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowsByPayloadId: async (payloadId) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow/api/get_workflows_by_payload/${payloadId}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createPayloadWorkflow: async (payload) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/payload/workflow/api/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            updatePayloadWorkflow: async (id, payload) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/payload/workflow/api/${id}/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            deletePayloadWorkflow: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/payload/workflow/api/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Payload workflow step API
            fetchAllPayloadWorkflowSteps :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-step/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowStep: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-step/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowStepsByWorkflowId: async (workflowId) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-step/api/get_steps_by_workflow/${workflowId}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createPayloadWorkflowStep: async (payload) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/payload/workflow-step/api/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            updatePayloadWorkflowStep: async (id, payload) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/payload/workflow-step/api/${id}/`, payload);
              } catch (error) {
                console.log(error.message);
              }
            },
            deletePayloadWorkflowStep: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/payload/workflow-step/api/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Payload workflow task API
            fetchAllPayloadWorkflowTasks :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-task/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowTask: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-task/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowTasksByPayloadId: async (payloadId, page = 1, pageSize = 10) => {
              try {
                const params = new URLSearchParams();
                params.set('page', page);
                params.set('page_size', pageSize);
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-task/api/get_tasks_by_payload/${payloadId}/?${params.toString()}`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchPayloadWorkflowTasksByWorkflowId: async (workflowId, page = 1, pageSize = 10) => {
              try {
                const params = new URLSearchParams();
                params.set('page', page);
                params.set('page_size', pageSize);
                return this.mozartApi.get(`${this.payloadapiurl}/payload/workflow-task/api/get_tasks_by_workflow/${workflowId}/?${params.toString()}`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Integration connection API
            fetchAllIntegrationConnections :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/integration/connection/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchIntegrationConnection: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/integration/connection/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createIntegrationConnection: async (connection) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/integration/connection/api/`, connection);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateIntegrationConnection: async (id, connection) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/integration/connection/api/${id}/`, connection);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteIntegrationConnection: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/integration/connection/api/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Integration action API
            fetchAllIntegrationActions :  async () =>{
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/integration/action/api/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchIntegrationAction: async (guid) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/integration/action/api/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchIntegrationActionsByConnectionId: async (connectionId) => {
              try {
                return this.mozartApi.get(`${this.payloadapiurl}/integration/action/api/get_actions_by_connection/${connectionId}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createIntegrationAction: async (action) => {
              try {
                return this.mozartApi.post(`${this.payloadapiurl}/integration/action/api/`, action);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateIntegrationAction: async (id, action) => {
              try {
                return this.mozartApi.put(`${this.payloadapiurl}/integration/action/api/${id}/`, action);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteIntegrationAction: async (id) => {
              try {
                return this.mozartApi.delete(`${this.payloadapiurl}/integration/action/api/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Status Code API
            fetchAllStatusCodes :  async () =>{
              try {
                console.log("Fetching all Status Code")
                return this.mozartApi.get(`${this.coreurl}/status_code/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchStatusCode: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/status_code/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createStatusCode: async (status_code) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/status_code/`, status_code);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateStatusCode: async (id, status_code) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/status_code/${id}/`, status_code);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteStatusCode: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/status_code/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Types API
            fetchAllRobotTypes :  async () =>{
              try {
                console.log("Fetching all types")
                return this.mozartApi.get(`${this.coreurl}/type/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchRobotType: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/type/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createRobotType: async (type) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/type/`, type);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateRobotType: async (id, type) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/type/${id}/`, type);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteRobotType: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/type/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Software API
            fetchAllRobotSoftwareVersions: async () =>{
              try {
                return this.mozartApi.get(`${this.coreurl}/software/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchRobotSoftwareVersion: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/software/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createRobotSoftwareVersion: async (software) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/software/`, software);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateRobotSoftwareVersion: async (id, software) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/software/${id}/`, software);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteRobotSoftwareVersion: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/software/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Site API
            fetchAllRobotSites: async () =>{
              try {
                return this.mozartApi.get(`${this.coreurl}/site/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchRobotSite: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/site/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createRobotSite: async (site) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/site/`, site);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateRobotSite: async (id, site) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/site/${id}/`, site);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteRobotSite: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/site/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Version API
            fetchAllRobotVersions: async () =>{
              try {
                return this.mozartApi.get(`${this.coreurl}/version/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchRobotVersion: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/version/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createRobotVersion: async (version) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/version/`, version);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateRobotVersion: async (id, version) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/version/${id}/`, version);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteRobotVersion: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/version/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Map API
            fetchAllMaps: async (robot_guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/map/get_maps/${robot_guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchMap: async (guid) => {
              try {
                  return this.mozartApi.get(`${this.coreurl}/map/${guid}/`);
              } catch (error) {
                  console.log(error.message);
              }
          }, 
          // Robot Waypoint API
            fetchWaypoints :  async (map_guid) =>{
              try {
                // console.log("Fetching all waypoint from ", map_name)
                return this.mozartApi.get(`${this.coreurl}/waypoint/get_waypoints/${map_guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            previewNavigationRoute: async (robotId, mapId, target, requestOptions = {}) => {
              return this.mozartApi.post(`${this.coreurl}/waypoint/route-preview/`, {
                robotId,
                mapId,
                target,
              }, undefined, false, requestOptions);
            },
            dispatchNavigationRoute: async (routePlanId, taskIds = []) => {
              return this.mozartApi.post(`${this.coreurl}/waypoint/route-dispatch/`, {
                routePlanId,
                taskIds,
              });
            },
            fetchActiveMission: async (robotId) => {
              return this.mozartApi.get(`${this.coreurl}/schedule/active/${robotId}/`);
            },
            controlActiveMission: async (robotId, action) => {
              return this.mozartApi.post(`${this.coreurl}/schedule/active/${robotId}/control/`, { action });
            },
          // Robot Status API
            fetchRobotStatus: async (guid) => {
              try {
                let response = await this.mozartApi.get(`${this.coreurl}/status/${guid}/`);
                // console.log(response)
                return response
              } catch (error) {
                // console.log(error.message);
                return {}
              }
            },
          // Robot Table API
            fetchRobotData: async (robot_guid) => {
              if(robot_guid === 0) {
                // Do fetch all
                try {
                  return this.mozartApi.get(`${this.coreurl}/robot/`);
                } catch (error) {
                  console.log(error.message);
                }
              } else {
                // Fetch using robot robot_guid
                try {
                  return this.mozartApi.get(`${this.coreurl}/robot/${robot_guid}/`);
                } catch (error) {
                  console.log(error.message);
                }
              }
            },
            registerRobot: async (robot) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/robot/`, robot);
              } catch (error) {
                console.log(error.message);
              }
            },
            activateRobot: async (key) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/robot/activate/`, { key: key });
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot livestream API
            createRobotLivestream: async (livestream) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/livestream/`, livestream);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchAllRobotLivestreams: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/livestream/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchLivestreamInfoByRobotId: async (robot_guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/livestream/get_livestream_info/${robot_guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchLivestreamBearerToken: async (guid) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/livestream/${guid}/bearer_token/`);
              } catch (error) {
                console.log(error.message);
                throw error;
              }
            },
            fetchLivestreamInfo: async (guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/livestream/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            activateLivestream: async (data) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/livestream/livestream_action/`, data);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateLivestream: async (id, livestream) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/livestream/${id}/`, livestream);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteLivestream: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/livestream/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Task API
            fetchTaskInfo: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/task/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createTask: async (task) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/task/`, task);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateTask: async (id, task) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/task/${id}/`, task);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteTask: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/task/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Tasklist API
            fetchTasklistInfo: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/tasklist/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createTasklist: async (tasklist) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/tasklist/`, tasklist);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateTasklist: async (id, tasklist) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/tasklist/${id}/`, tasklist);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteTasklist: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/tasklist/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Mission API
            fetchMissionInfo: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/mission/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createMission: async (mission) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/mission/`, mission);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateMission: async (id, mission) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/mission/${id}/`, mission);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteMission: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/mission/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchMissionTasklist: async (id) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/mission/tasklist/?missiontasklist_id=${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchMissionsByMap: async (id) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/mission/get_missions/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Schedule API
            fetchScheduleInfo: async (robot_guid) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/schedule/get_schedules/${robot_guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createSchedule: async (schedule) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/schedule/`, schedule);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateSchedule: async (id, schedule) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/schedule/${id}/`, schedule);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteSchedule: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/schedule/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            repullScheduleForRobot: async (robot_name) => {
              try {
                return this.mozartApi.get(`${this.coreurl}/schedule/request_schedules/${robot_name}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Endpoint API
            fetchAllEndpoints: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/endpoint/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createEndpoint: async (endpoint) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/endpoint/`, endpoint);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateEndpoint: async (id, endpoint) => {
              try {
                return this.mozartApi.put(`${this.coreurl}/endpoint/${id}/`, endpoint);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteEndpoint: async (id) => {
              try {
                return this.mozartApi.delete(`${this.coreurl}/endpoint/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Assigned Endpoint API
            fetchAllAssignedEndpoints: async () => {
              try {
                return this.mozartApi.get(`${this.coreurl}/assigned_endpoint/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createAssignedEndpoint: async (assigned_endpoint) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/assigned_endpoint/`, assigned_endpoint);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteAssignedEndpointByRobotTableId: async (robot_table_id) => {
              try {
                return this.mozartApi.post(`${this.coreurl}/assigned_endpoint/delete_assigned_endpoint_by_robot_table_id/`, robot_table_id);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot AI Config API
            fetchAllAIConfigs: async () => {
              try {
                return this.mozartApi.get(`${this.aiapiurl}/ai_config/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createAIConfig: async (ai_config) => {
              try {
                return this.mozartApi.post(`${this.aiapiurl}/ai_config/`, ai_config);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteAIConfigByRobotTableId: async (robot_table_id) => {
              try {
                return this.mozartApi.post(`${this.aiapiurl}/ai_config/delete_ai_configs_by_robot_table_id/`, robot_table_id);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot AI Object API
            fetchAllAIObjects: async () => {
              try {
                return this.mozartApi.get(`${this.aiapiurl}/ai_object/object/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createAIObject: async (aiobject) => {
              try {
                return this.mozartApi.post(`${this.aiapiurl}/ai_object/object/`, aiobject);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateAIObject: async (id, aiobject) => {
              try {
                return this.mozartApi.put(`${this.aiapiurl}/ai_object/object/${id}/`, aiobject);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteAIObject: async (id) => {
              try {
                return this.mozartApi.delete(`${this.aiapiurl}/ai_object/object/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Alerts API
            // fetchAllAlerts: async () => {
            //   try {
            //     return this.mozartApi.get(`${this.alertapiurl}/alert/`);
            //   } catch (error) {
            //     console.log(error.message);
            //   }
            // },
            fetchAlertsPage: async (page, pageSize, searchText="") => {
              try {
                return this.mozartApi.get(`${this.alertapiurl}/alert/?page=${page}&page_size=${pageSize}&search=${searchText}`);
              } catch (error) {
                console.log(error.message);
              }
            },
            fetchAlertsPageByRobotId: async (robotId, page, pageSize, searchText="") => {
              try {
                return this.mozartApi.get(`${this.alertapiurl}/alert/get_alerts_by_robot_id/${robotId}/?page=${page}&page_size=${pageSize}&search=${searchText}`);
              } catch (error) {
                console.log(error.message);
              }
            },
            // createAlert: async (aiobject) => {
            //   try {
            //     return this.mozartApi.post(`${this.aiapiurl}/ai_object/object/`, aiobject);
            //   } catch (error) {
            //     console.log(error.message);
            //   }
            // },
            fetchAlert: async (guid) => {
              try {
                return this.mozartApi.get(`${this.alertapiurl}/alert/${guid}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateAlert: async (id, alert) => {
              try {
                return this.mozartApi.put(`${this.alertapiurl}/alert/${id}/`, alert);
              } catch (error) {
                console.log(error.message);
              }
            },
            // deleteAlert: async (id) => {
            //   try {
            //     return this.mozartApi.delete(`${this.aiapiurl}/ai_object/object/${id}/`);
            //   } catch (error) {
            //     console.log(error.message);
            //   }
            // },
          // Robot AI Broadcast API
            fetchAllAIBroadcasts: async () => {
              try {
                return this.mozartApi.get(`${this.aiapiurl}/ai_object/broadcastmessage/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createAIBroadcast: async (broadcastmessage) => {
              try {
                return this.mozartApi.post(`${this.aiapiurl}/ai_object/broadcastmessage/`, broadcastmessage);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateAIBroadcast: async (id, broadcastmessage) => {
              try {
                return this.mozartApi.put(`${this.aiapiurl}/ai_object/broadcastmessage/${id}/`, broadcastmessage);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteAIBroadcast: async (id) => {
              try {
                return this.mozartApi.delete(`${this.aiapiurl}/ai_object/broadcastmessage/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot AI ScreenDisplay API
            fetchAllAIScreenDisplays: async () => {
              try {
                return this.mozartApi.get(`${this.aiapiurl}/ai_object/screendisplay/`);
              } catch (error) {
                console.log(error.message);
              }
            },
            createAIScreenDisplay: async (screendisplay) => {
              try {
                return this.mozartApi.post(`${this.aiapiurl}/ai_object/screendisplay/`, screendisplay);
              } catch (error) {
                console.log(error.message);
              }
            },
            updateAIScreenDisplay: async (id, screendisplay) => {
              try {
                return this.mozartApi.put(`${this.aiapiurl}/ai_object/screendisplay/${id}/`, screendisplay);
              } catch (error) {
                console.log(error.message);
              }
            },
            deleteAIScreenDisplay: async (id) => {
              try {
                return this.mozartApi.delete(`${this.aiapiurl}/ai_object/screendisplay/${id}/`);
              } catch (error) {
                console.log(error.message);
              }
            },
          // Robot Other API
            sendRobotScheduleRMF: async(schedule)=>{
              try {
                return this.mozartApi.post(`http://192.168.2.124:8000/scheduled_tasks`, schedule);
              } catch (error) {
                console.log(error.message);
              }
            },
            sendRobotMissionRMF: async(mission)=>{
              try {
                return this.mozartApi.post(`http://192.168.2.124:8000/tasks/dispatch_task`, mission);
              } catch (error) {
                console.log(error.message);
              }
            },
          }
    }
}
